import { create } from 'zustand'
import { LoginUsedStore } from './types'
import { persist } from 'zustand/middleware'

export const useLoginUsedStore = create<LoginUsedStore>()(
  persist(
    set => {
      return {
        loginUsedToAccess: null,
        setLoginUsedToAccess: loginUsed => {
          set({ loginUsedToAccess: loginUsed })
        },
      }
    },
    {
      name: 'loginUsedToAccess',
      getStorage: () => sessionStorage,
    },
  ),
)
